<template>
  <div
    role="complementary"
    aria-label="Scheduled maintenance"
    class="bg-royal-blue-20">
    <div class="container py-4">
      <p>
        For submissions from <strong>1 July 2026</strong> an APC will apply to all articles accepted in <i>Chemical Science</i>. Use our journal finder to check if your APC is covered by an institutional agreement with us. Note, if your institution has an agreement with us that covers APCs, you will be notified of this at article acceptance. Details of the APC and discounted rates are found <a
          class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
          href="https://www.rsc.org/publishing/open-access/payments-and-funding"
          target="_blank"
          id="lnk-payements-funding"
        >
          here</a>.
      </p>
    </div>
  </div>
</template>
